import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { FavoriteHtsNumberSearchModel } from '@app/data-layer/models/common/favorite-hts-number-search.model';
import { CUSTOM_MASK } from '@helpers/custom-validator';
import { ReplaySubject } from 'rxjs';

@Component({
  selector: 'app-bina-catalog-search',
  templateUrl: './bina-catalog-search.component.html',
  styleUrls: ['./bina-catalog-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BinaCatalogSearchComponent implements OnInit {
  @Input() public isFullWidth: boolean = false;
  @Input() public isShowClearButton: boolean = true;
  @Input() public companyId: number;
  /** Text the box opens with (the host runs that search itself). */
  @Input() public initialValue: string | null = null;
  @Output() public search: EventEmitter<FavoriteHtsNumberSearchModel> = new EventEmitter<FavoriteHtsNumberSearchModel>();

  public CUSTOM_MASK: any = CUSTOM_MASK;
  public searchForm: UntypedFormGroup;

  private destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>();

  constructor(private formBuilder: UntypedFormBuilder) {}

  public ngOnInit(): void {
    this.initSearchForm();
  }

  public onSubmit(): void {
    this.search.emit({
      ...this.searchForm.value,
      companyId: this.companyId,
    });
  }

  public clearFilters(): void {
    this.searchForm.reset();
    this.search.emit({
      ...this.searchForm.value,
      companyId: this.companyId,
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  private initSearchForm(): void {
    this.searchForm = this.formBuilder.group({
      companyId: this.companyId,
      searchParameter: [this.initialValue || null],
      offset: [null],
      limit: [null],
    });
  }
}
